var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5b332;}.cls-1,.cls-2{stroke:#f5b332;stroke-miterlimit:10;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.91 6.58 8.71 6.58 5.61 11.95 8.71 17.32 14.91 17.32 18.01 11.95 14.91 6.58"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.58,
    y1: 11.95,
    x2: -8.83,
    y2: 11.95
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.22 11.95 18.02 11.95 14.93 17.32 18.02 22.68 24.22 22.68 27.32 17.32 24.22 11.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33.45 6.58 27.26 6.58 24.16 11.95 27.26 17.32 33.45 17.32 36.55 11.95 33.45 6.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.22 1.21 18.02 1.21 14.93 6.58 18.02 11.95 24.22 11.95 27.32 6.58 24.22 1.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "42.72 11.95 36.52 11.95 33.42 17.32 36.52 22.68 42.72 22.68 45.81 17.32 42.72 11.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "61.35 11.95 55.15 11.95 52.05 17.32 55.15 22.68 61.35 22.68 64.45 17.32 61.35 11.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "52.01 17.32 45.81 17.32 42.71 22.68 45.81 28.05 52.01 28.05 55.11 22.68 52.01 17.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "61.35 22.68 55.15 22.68 52.05 28.05 55.15 33.42 61.35 33.42 64.45 28.05 61.35 22.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "70.69 28.05 64.49 28.05 61.39 33.42 64.49 38.79 70.69 38.79 73.79 33.42 70.69 28.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "79.98 22.68 73.78 22.68 70.68 28.05 73.78 33.42 79.98 33.42 83.08 28.05 79.98 22.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "89.25 17.32 83.06 17.32 79.95 22.68 83.06 28.05 89.25 28.05 92.35 22.68 89.25 17.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 127.09,
    y1: 22.68,
    x2: 92.54,
    y2: 22.68
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg3);
export default __webpack_public_path__ + "static/media/BG_3.4c40f7e7c83d876678a6ea654f66c2d8.svg";
export { ForwardRef as ReactComponent };